import { 
  GUIDELINES_REQUEST,
  GUIDELINE_REJECT,
  GUIDELINE_ADD,
  GUIDELINE_UPDATE,
  GUIDELINE_SILENCE_UPDATE,
  GUIDELINE_CHANGE_PHASE,
  GUIDELINE_FINAL_PUBLICATION,
  GUIDELINE_CLOSE_UPLOAD_REVIEW_USER_PHASE,
  GUIDELINE_FORMAL_CHECK_APPROVAL,
  GUIDELINE_SUBMIT_NATIONAL_DELEGATE_REVIEW,
  GUIDELINE_DELETE,
  GUIDELINE_DELETE_FILE_BY_ID,
  GUIDELINE_REQUEST_BY_ID,
  GUIDELINES_SUCCESS,
  GUIDELINES_EMPTY,
  GUIDELINE_LIST_PHASES_BY_ID,
  GUIDELINE_UPDATE_DEADLINE,
  GUIDELINE_UPDATE_COI,
  GUIDELINE_ADMIN_UPLOAD_APPROVE,
  GUIDELINES_ERROR,
  GUIDELINE_SET_QUERY,
  GUIDELINES_FILTER_DRAFT } from '../actions/guidelines';
import Api from '@/services/Api';
import { GuidelinePhases } from '@/lib/guideline.js';

const state = {
  status: '',
  guideline_query: localStorage.getItem('guidelines.guidelineQuery')?localStorage.getItem('guidelines.guidelineQuery'):'',
  phaseFilter: localStorage.getItem('guidelines.phaseFilter')?JSON.parse(localStorage.getItem('guidelines.phaseFilter')):[
    GuidelinePhases.draft,
    GuidelinePhases.submitted,
    GuidelinePhases.rejected,
    GuidelinePhases.formalCheckApproval,
    GuidelinePhases.preApproved,
    GuidelinePhases.uploadedForGpcReview,
    GuidelinePhases.uploadGpcReviewed,
    GuidelinePhases.uploadGpcReviewedEnd,
    GuidelinePhases.uploadedForReview,
    GuidelinePhases.parallelReview,
    GuidelinePhases.parallelReviewed,
    GuidelinePhases.parallelReviewEnd,
    GuidelinePhases.uploadReviewed,
    GuidelinePhases.uploadReviewedEnd,
    GuidelinePhases.reviewByNationalDelegates,
    GuidelinePhases.reviewedByNationalDelegates,
    GuidelinePhases.reviewByNationalDelegatesEnd,
    GuidelinePhases.gpcFinalApproval,
    GuidelinePhases.gpcFinalHold,
    GuidelinePhases.boardApproval,
    GuidelinePhases.boardApprovalApproved,
    GuidelinePhases.boardApprovalOnHold,
    GuidelinePhases.finalPublish,
  ],
  current_page: localStorage.getItem('guidelines.current_page')?localStorage.getItem('guidelines.current_page'):1,

  reloadComponent: 0,
};

const getters = {
  getPhaseFilter: state => { 
    return state.phaseFilter;
  },

  reloadComponent: state => {
    return state.reloadComponent;
  }
};

const actions = {
  [GUIDELINES_REQUEST]: ({commit, state}, params) => {
    if (params.page == undefined) {
      params.page = state.current_page;
    }

    commit('GUIDELINES_STORE_FILTER', params.phases);

    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().get('/guidelines', {
          params: {
            page : params.page,
            phases : params.phases,
            query : state.guideline_query,
          }
        })
      .then((response) => {
        commit(GUIDELINES_SUCCESS, response);

        if (response.data.data.length == 0) {
          commit(GUIDELINES_EMPTY);
        }

        resolve(response);
      })
      .catch((error) => {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    });
  },
  [GUIDELINE_ADD]: ({commit, dispatch}, guideline) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().post('/guidelines/', guideline)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS, response);
        resolve(response);
      })
      .catch((error) => {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_UPDATE]: ({commit}, guideline) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().patch('/guidelines/update_draft/' + guideline.id, guideline)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_SILENCE_UPDATE]: ({commit}, guideline) => {
    return new Promise((resolve, reject) => {
      Api().put('/guidelines/' + guideline.id, guideline)
      .then(function (response) {
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      });
    })
  },

  [GUIDELINE_CHANGE_PHASE]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)
      Api().patch('/guidelines/' + args.id, args)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_FINAL_PUBLICATION]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      Api().post('/guidelines/' + args.id + '/final-publication', args)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_CLOSE_UPLOAD_REVIEW_USER_PHASE]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)
      Api().post('/guidelines/' + args.id + '/finish-review/', args)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_FORMAL_CHECK_APPROVAL]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)
      Api().post('/guidelines/' + args.id + '/formal-check-approval/', args)
          .then(function (response) {
            commit(GUIDELINES_SUCCESS);
            resolve(response);
          })
          .catch(function (error) {
            commit(GUIDELINES_ERROR);
            reject(error);
          });
    })
  },

  [GUIDELINE_SUBMIT_NATIONAL_DELEGATE_REVIEW]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)
      Api().post('/guidelines/' + args.id + '/national-delegate-review/', args)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_REQUEST_BY_ID]: ({commit, dispatch}, id) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST);
      Api().get('/guidelines/' + id)
        .then(function (response) {
          commit(GUIDELINES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GUIDELINES_ERROR);
          reject(error);
        });
    })
  },

  [GUIDELINE_DELETE]: ({commit}, row) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().delete('/guidelines/' + row.id)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINES_FILTER_DRAFT]: ({commit}) => {
    commit(GUIDELINES_FILTER_DRAFT);
  },

  [GUIDELINE_DELETE_FILE_BY_ID]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().get('/delete-file/' + args.gid + '/' + args.fid)
      .then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_REJECT]: ({commit}, row) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().post('/guidelines/reject/' + row.id, row).then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    });
  },

  [GUIDELINE_LIST_PHASES_BY_ID]: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().get('/guidelines/phases/' + id).then(function (response) {
        commit(GUIDELINES_SUCCESS);

        if (response.data.data.length == 0) {
          commit(GUIDELINES_EMPTY);
        }

        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    })
  },

  [GUIDELINE_UPDATE_DEADLINE]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().post('/guidelines/update_deadline/' + args.gid, args).then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    });
  },

  [GUIDELINE_UPDATE_COI]: ({commit}, args) => {
      return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().post('/guidelines/update_coi/' + args.gid, {coiUsers: args.coiUsers}).then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    });
  },

  [GUIDELINE_ADMIN_UPLOAD_APPROVE]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(GUIDELINES_REQUEST)

      Api().get('/guidelines/admin_upload_approve/' + args.id).then(function (response) {
        commit(GUIDELINES_SUCCESS);
        resolve(response);
      })
      .catch(function (error) {
        commit(GUIDELINES_ERROR);
        reject(error);
      });
    });
  }
};

const mutations = {
  [GUIDELINES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GUIDELINES_SUCCESS]: (state, response) => {
    state.status = 'success';

    if (response != null) {
      if ((response.data.meta != undefined) && (response.data.meta.current_page != undefined)) {
        state.current_page = response.data.meta.current_page;
        localStorage.setItem('guidelines.current_page', response.data.meta.current_page)
      }
    }
  },
  [GUIDELINES_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [GUIDELINES_ERROR]: (state) => {
    state.status = 'error';
  },

  ['GUIDELINES_STORE_FILTER']: (state, filter) => {
    localStorage.setItem('guidelines.phaseFilter', JSON.stringify(filter));
    state.phaseFilter = filter;
  },

  [GUIDELINE_SET_QUERY]: (state, payload) => {
    localStorage.setItem('guidelines.guidelineQuery', payload);
    state.guideline_query = payload;
  },

  ['GUIDELINES_RESET_FILTER']: (state, filter) => {
    state.phaseFilter = [
      GuidelinePhases.draft,
      GuidelinePhases.submitted,
      GuidelinePhases.rejected,
      GuidelinePhases.preApproved,
      GuidelinePhases.formalCheckApproval,
      GuidelinePhases.uploadedForGpcReview,
      GuidelinePhases.uploadGpcReviewed,
      GuidelinePhases.uploadedForReview,
      GuidelinePhases.parallelReview,
      GuidelinePhases.parallelReviewed,
      GuidelinePhases.parallelReviewEnd,
      GuidelinePhases.uploadReviewed,
      GuidelinePhases.uploadReviewedEnd,
      GuidelinePhases.reviewByNationalDelegates,
      GuidelinePhases.reviewedByNationalDelegates,
      GuidelinePhases.reviewByNationalDelegatesEnd,
      GuidelinePhases.boardApproval,
      GuidelinePhases.boardApprovalApproved,
      GuidelinePhases.boardApprovalOnHold,
      GuidelinePhases.finalPublish,
    ];
    localStorage.setItem('guidelines.phaseFilter', JSON.stringify(state.phaseFilter));
  },

  [GUIDELINES_FILTER_DRAFT]: (state, filter) => {
    state.phaseFilter = [
      GuidelinePhases.draft,
    ];
    localStorage.setItem('guidelines.phaseFilter', JSON.stringify(state.phaseFilter));
    state.reloadComponent = 1;
  },

  ['RESET_RELOAD_VALUE']: (state) => {
    state.reloadComponent = 0;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
